// index.js
import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import App from "./App";
import store from "./Store"; // Ensure the file path and casing are correct
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';

import axios from "axios";

//axios.defaults.baseURL = "http://172.30.30.96:2500/";
//axios.defaults.baseURL = "http://localhost:51976/";
//axios.defaults.baseURL = "http://172.30.30.96:9000/api/attendance/";
 axios.defaults.baseURL = "https://esystems.cdl.lk/backend/AttendMe2/";
//axios.defaults.baseURL = "https://esystems.cdl.lk/backend-test/AttendMe2/";
//axios.defaults.baseURL = "https://attendmetest.dockyardsoftware.site:4953/";
//axios.defaults.baseURL = "https://attendme.dockyardsoftware.site:4953/";

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  
  <Provider store={store}> 
   <App />     
  </Provider>,
  document.getElementById("root")
);
